import { __rest } from "tslib";
import React, { useMemo } from 'react';
import isEqualWith from 'lodash/isEqualWith';
import { useSelector, useDispatch } from 'react-redux';
import { DuperbrowseStreamContext, } from './DuperbrowseStreamContext';
import { getLastViewedItem } from '../redux/selectors';
import { loadDuperbrowse } from '../redux/actionCreators';
import { useDeepEqualCustomMemo } from '../../utils/hooks/useDeepEqualMemo';
import { getDeviationEntityId } from '../../redux/normalizr/schemas/deviation';
var DuperbrowseStreamContextProvider = function (_a) {
    var children = _a.children, stream = _a.stream;
    var lastViewedItem = useSelector(getLastViewedItem);
    var dispatch = useDispatch();
    var memodStream = useDeepEqualCustomMemo(stream, function (a, b) {
        var _a, _b, _c, _d;
        // use default comparison for loadable and normalized streams
        if (!((_b = (_a = a === null || a === void 0 ? void 0 : a.items) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.hasOwnProperty('deviationId')) ||
            !((_d = (_c = b === null || b === void 0 ? void 0 : b.items) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.hasOwnProperty('deviationId'))) {
            return undefined;
        }
        var _e = a, aItems = _e.items, aWithoutItems = __rest(_e, ["items"]);
        var _f = b, bItems = _f.items, bWithoutItems = __rest(_f, ["items"]);
        if (!isEqualWith(aWithoutItems, bWithoutItems)) {
            return false;
        }
        return isEqualWith(aItems, bItems, function (aItem, bItem) {
            return getDeviationEntityId(aItem) === getDeviationEntityId(bItem);
        });
    });
    var contextProps = useMemo(function () { return ({
        stream: memodStream,
        lastViewedItem: lastViewedItem,
        loadDuperbrowse: function (itemId, streamId) {
            return dispatch(loadDuperbrowse(itemId, streamId));
        },
    }); }, [dispatch, lastViewedItem, memodStream]);
    return (React.createElement(DuperbrowseStreamContext.Provider, { value: contextProps }, children));
};
DuperbrowseStreamContextProvider.displayName =
    'DuperbrowseStreamContextProvider';
export default DuperbrowseStreamContextProvider;
//# sourceMappingURL=DuperbrowseStreamContextProvider.js.map